import { isValidObjectId } from "@utils";
import {
  WIZARD_MODES,
  WIZARD_INITIAL_DATA,
  USE_CASES,
  LATEST_TAG,
  RELEASE_NAME_REGEX,
  RELEASE_NAME_MAX_LENGTH,
  SHA_REGEX,
  UUID_V4_REGEX,
  ERROR_MESSAGES,
  DEFAULT_TTL_HOURS,
  NLU_MODES,
  VALID_CONFIG_ID_VALUES,
  FIELD_IDS,
  SPLIT_DRAFT_PREVIEW_MODES,
  getServicesForUseCase,
} from "./DeployWizard.consts";

export const validateReleaseName = (value, existingNames, isEdit) => {
  if (!value) return ERROR_MESSAGES.REQUIRED_FIELD;

  const formatted = value.replace(/ /g, "-");
  if (!RELEASE_NAME_REGEX.test(formatted)) {
    return ERROR_MESSAGES.INVALID_RELEASE_NAME;
  }
  if (formatted.length > RELEASE_NAME_MAX_LENGTH) {
    return ERROR_MESSAGES.RELEASE_NAME_TOO_LONG;
  }
  if (!isEdit && existingNames.includes(formatted)) {
    return ERROR_MESSAGES.RELEASE_NAME_EXISTS;
  }
  return "";
};

export const validateShaField = (value, allowLatest = true) => {
  if (!value || value.trim() === "") return "";
  if (allowLatest && value === LATEST_TAG) return "";
  if (!SHA_REGEX.test(value)) return ERROR_MESSAGES.INVALID_SHA;
  return "";
};

export const validateAssistantId = (value) => {
  if (!value || value.trim() === "") return "";
  if (!UUID_V4_REGEX.test(value.trim())) return ERROR_MESSAGES.INVALID_ASSISTANT_ID;
  return "";
};

export const validateConfigId = (value) => {
  if (!value || value.trim() === "") return "";
  const trimmed = value.trim();
  if (trimmed === VALID_CONFIG_ID_VALUES.ACTIVE || trimmed === VALID_CONFIG_ID_VALUES.DRAFT || isValidObjectId(trimmed)) {
    return "";
  }
  return ERROR_MESSAGES.INVALID_CONFIG_ID;
};

export const validateMemory = (value) => {
  if (!value || (typeof value === "string" && value.trim() === "")) return "";
  const num = Number(value);
  if (isNaN(num) || num < 1 || num > 10) return ERROR_MESSAGES.MEMORY_OUT_OF_RANGE;
  return "";
};

export const getInitialUseCase = (mode, initialData) => {
  const isEdit = mode === WIZARD_MODES.EDIT;
  const isReactivate = mode === WIZARD_MODES.REACTIVATE;
  const isView = mode === WIZARD_MODES.VIEW;

  if (isEdit || isReactivate || isView) {
    return initialData?.useCase && USE_CASES[initialData.useCase]
      ? initialData.useCase
      : USE_CASES.ADVANCED.id;
  }
  return initialData?.useCase || null;
};

export const getInitialFormData = (mode, initialData) => {
  const isEdit = mode === WIZARD_MODES.EDIT;
  const isReactivate = mode === WIZARD_MODES.REACTIVATE;
  const isView = mode === WIZARD_MODES.VIEW;

  if (isEdit || isReactivate || isView) {
    const data = { ...WIZARD_INITIAL_DATA };
    Object.keys(data).forEach((key) => {
      if (initialData[key] !== undefined) {
        data[key] = initialData[key];
      }
    });
    if (isReactivate) {
      data.ttlHours = DEFAULT_TTL_HOURS;
    }
    return data;
  }
  return { ...WIZARD_INITIAL_DATA, ...initialData };
};

export const buildPayload = (formData, selectedUseCase) => {
  const payload = { ...formData };

  const useCase = USE_CASES[selectedUseCase];
  const effectiveNluMode = payload[FIELD_IDS.NLU_MODE] || useCase?.nluMode;
  if (effectiveNluMode === NLU_MODES.DEDICATED) {
    payload.nluRuntimeModes = [NLU_MODES.DEDICATED];
  } else if (effectiveNluMode === NLU_MODES.API && payload[FIELD_IDS.NLU_RUNTIME_TAG]) {
    payload.nluRuntimeModes = [NLU_MODES.API];
  }
  delete payload[FIELD_IDS.NLU_MODE];

  const hasWidgetServerTag = Boolean(payload.widgetServerTag && payload.widgetServerTag !== "");
  if (useCase?.splitDraftPreview === SPLIT_DRAFT_PREVIEW_MODES.ALWAYS
    || (useCase?.splitDraftPreview === SPLIT_DRAFT_PREVIEW_MODES.WITH_WIDGET_SERVER && hasWidgetServerTag)) {
    payload.splitDraftPreview = true;
  }

  Object.keys(payload).forEach((key) => {
    const val = payload[key];
    if (val === "" || val === undefined || val === false || (Array.isArray(val) && val.length === 0)) {
      delete payload[key];
    }
  });

  delete payload[FIELD_IDS.USE_CASE];
  payload.useCase = selectedUseCase;
  return payload;
};
